var map = {
	"./arrowBlue.svg": "aqbc",
	"./burger.svg": "JYhB",
	"./calendarIcon.svg": "lcqm",
	"./check.svg": "7ZS0",
	"./checkIcon.svg": "dzWw",
	"./classThreeIcon.svg": "hDG+",
	"./classTime.svg": "Z/01",
	"./close.svg": "toIl",
	"./down.svg": "LHwD",
	"./fbIcon.svg": "xdDD",
	"./footerLogo.svg": "u/mu",
	"./freeMail.svg": "9JMl",
	"./googleIcon.svg": "Ec/5",
	"./headerLogo.svg": "LJGH",
	"./homeEditSmallIcon.svg": "29jv",
	"./homeFatherIcon.svg": "pOiG",
	"./homeGroupIcon.svg": "zDXY",
	"./homeInternationalIcon.svg": "aOC1",
	"./homeLiveIcon.svg": "ry3L",
	"./homePortfolioSmallIcon.svg": "Hc7N",
	"./homeTeacherSmallIcon.svg": "lpng",
	"./homeworkIcon.svg": "hRGJ",
	"./interfaceProject.svg": "Iclb",
	"./interfaceSystem.svg": "Dyxe",
	"./interfaceTeacher.svg": "kog+",
	"./liveIcon.svg": "TmCY",
	"./mailIcon.svg": "1HYd",
	"./messenger.svg": "NFtF",
	"./screenIcon.svg": "NZtZ",
	"./studying.svg": "BM4h",
	"./timeIcon.svg": "ZRFX"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 10